import { render, staticRenderFns } from "./MaisMedicos.vue?vue&type=template&id=d213c8f4"
import script from "./MaisMedicos.vue?vue&type=script&lang=js"
export * from "./MaisMedicos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports